//containers -> Loout -> index.js
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {submitLogOut} from '../../actions/login';


class Logout extends Component {

  componentWillMount(){
    sessionStorage.removeItem('adminEmail');
    sessionStorage.removeItem('adminPassword');
    sessionStorage.removeItem('adminToken');
    this.props.history.push("/login");
    this.props.dispatch(submitLogOut());

  }

  render(){
    return(<div></div>)
  }
}

const mapStateToProps=(state) =>{
  return {
    authenticated : state.login.authenticated
  };
}

export default connect(mapStateToProps)(Logout);



// WEBPACK FOOTER //
// ./src/containers/Logout/index.js